"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpError = void 0;
/**
 * Any http response status other than [200,299] as a result of HttpBaseApi's get, post, put or delete method is
 * thrown back as an instance of this error class
 */
class HttpError extends Error {
    name = 'HttpError';
    url;
    status;
    statusText;
    responseData;
    /**
     * Create an instance of HttpError
     * @param {string} message Error message
     * @param {string} url URL of the response
     * @param {string} status HTTP status code of the response
     * @param {string} statusText Status message corresponding to the HTTP status code
     * @param {unknown} responseData The resolved response of the request that resulted in creating this error
     */
    constructor(message, url, status, statusText, responseData) {
        super(message);
        if (status >= 200 && status <= 299) {
            throw new Error(`Cannot create HttpError for a successful response status ${status}. Status cannot be in the range [200, 299]`);
        }
        this.url = url;
        this.status = status;
        this.statusText = statusText;
        this.responseData = responseData;
    }
}
exports.HttpError = HttpError;
